import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type { PendingStrandLossWarning } from "../../models/caster.models";
import { StrandLossWarningRow } from "./StrandLossWarningRow";

interface StrandLossWarningsProps {
  warnings: PendingStrandLossWarning[];
  onOpenStrandLoss: (strandLossId: number) => void;
  action?: ReactNode;
}

const MAX_VISIBLE_WARNINGS = 5;

export const StrandLossWarnings = ({
  warnings,
  onOpenStrandLoss,
  action,
}: StrandLossWarningsProps) => {
  if (warnings.length === 0) return null;

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        mt: 0.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
          gridColumn: 2,
          minWidth: 0,
        }}
      >
        {warnings.slice(0, MAX_VISIBLE_WARNINGS).map((warning) => (
          <StrandLossWarningRow
            key={warning.strandLossId}
            strandNumber={warning.strand}
            heatName={warning.heatName}
            onClick={() => onOpenStrandLoss(warning.strandLossId)}
          />
        ))}
      </Box>
      <Box sx={{ gridColumn: 3, justifySelf: "center", pl: 1.5 }}>{action}</Box>
    </Box>
  );
};
